<!--  -->
<template>
	<div class="content">
		<cx-head v-if="windowWidth <= 768" />
		<b-container fluid>
			<img class="top_img" width="100%" src="../../static/img/function/top_img.png" v-if="windowWidth>768" />
			<img width="100%" src="../../static/img/function/top_img1.png" v-else/>
		</b-container>
		<!-- <div
      class="mianbao"
      toggleable="lg"
    >
      <div
        v-for="(item,index) in mianbaoList"
        :key="index"
        class="mianbao_item"
        :class="{active:index==i}"
      >{{item.label}}</div>
    </div> -->
		<!-- <div class="mianbao">
      <b-breadcrumb :items="mianbaoList"></b-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/media' }">媒体</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">企业动态</el-breadcrumb-item>
        <el-breadcrumb-item>文章详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
		<div class="article_state" v-loading="loading">
			<div class="title_view">
				<h3>{{ title }}</h3>
				<p style="color:#666;font-size:14px">{{ formatDate(date) }}</p>
			</div>
			<div class="article_cantent" v-html="textHtml"></div>
		</div>

	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import api from '../api/api.js';
import cxHead from '@/components/cx-head.vue';
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {
		cxHead,
	},
	name: 'async',
	metaInfo() {
		return {
			title: this.pageName, // set a title
			meta: [
				{
					// set meta
					name: 'keyWords',
					content: this.SeoKeyword,
				},
				{
					name: 'description',
					content: this.SeoDescription,
				},
			],
		};
	},
	data() {
		//这里存放数据
		return {
			windowWidth: window.innerWidth,
			loading: true,
			pageName: 'loading',
			SeoKeyword: '',
			SeoDescription: '',
			i: 0,
			type: 'audio',
			mianbaoList: [
				{
					text: '首页',
					href: '/',
				},
				{
					text: '媒体',
					href: '/media',
				},
				{
					text: '企业动态',
					href: '/news',
				},
				{
					text: '文章详情',
					// href: '/',
					active: true,
				},
			],

			title: '',
			date: '',
			textHtml: '',
			pageId: '',
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {},
	//方法集合
	methods: {

		formatDate(date) { //格式化日期
			if (date) {
				let date1 = new Date(date.replace(/-/g, '/'));
				date = this.common.formatDate(new Date(date1), 'yyyy年MM月dd日');
			}
			return date;
		},
		getCompanyRVCampingDataById(value) {
			let that = this;
			this.$axios
				.post(api.GetCompanyRVCampingDataById, {
					Id: value
					// wheres: "[{ name: 'Id', value:'" + value + "' }]",
				})
				.then(function (response) {
					// console.log('详细数据', response);
					let data = response.data.data;
					that.title = data.title;
					that.SeoKeyword = data.seoKeyword ? data.seoKeyword : '约你游·一站式房车旅游综合服务平台';
					that.SeoDescription = data.seoDescription
						? data.seoDescription
						: '约你游·一站式房车旅游综合服务平台';
					that.date = data.releaseDate;
					that.textHtml = data.content;
					that.loading = false;
					// that.newList = response.data.rows;
				})
				.catch(function (error) {
					console.log(error);
				});
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		// console.log(title);
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
		let id = this.$route.query.id;
		// this.pageId = this.$route.query.id;
		// this.title = this.$route.query.title;
		// this.date = this.$route.query.date;
		// this.textHtml = this.$route.query.textHtml;
		console.log(id);
		this.getCompanyRVCampingDataById(id);
		setTimeout(() => {
			this.pageName = this.title;
		}, 1000);
	},
	beforeCreate() { }, //生命周期 - 创建之前
	beforeMount() { }, //生命周期 - 挂载之前
	beforeUpdate() { }, //生命周期 - 更新之前
	updated() { }, //生命周期 - 更新之后
	beforeDestroy() { }, //生命周期 - 销毁之前
	destroyed() { }, //生命周期 - 销毁完成
	activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
	padding-bottom: 60px;
}

.container-fluid {
	padding-left: 0 !important;
	padding-right: 0 !important;
}

// .mianbao {
// 	display: flex;
// 	flex-direction: row;
// 	align-items: center;
// 	background: #fbfbfb;
// 	font-size: 14px;
// 	padding: 4px;
// }
.mianbao {
	background: #e9ecef;
}

.el-breadcrumb {
	padding: 0.75rem 0;
	width: 100%;
	max-width: 1200px;
	margin: 0 auto;
}

@media (min-width: 768px) {

	// .mianbao {
	// 	padding-left: 200px;
	// }
	.media_title {
		display: none;
	}

	.top_img {
		display: block
	}
	.article_cantent>>>img {
		object-fit: cover;
		width: 100% !important;
		margin: 0 auto;
	}
}

.title_view {
	border-bottom: 1px solid #f0f0f0;
}

@media (max-width: 576px) {
	.top_img {
		display: none
	}

	.mianbao_item {
		flex: 1;
	}

	.title_img1 {
		display: none;
	}

	.mianbao {
		display: none;
	}

	.media_title {
		display: block;
		color: #ff6537;
		font-size: 20px;
		font-weight: bold;
		margin: 10px;
	}

	.title_text {
		color: #ff6537;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		display: block !important;
		margin-top: 15px;
	}

	.article_cantent {
		margin: 10px 20px;
		text-align: left;
	}

	.article_cantent>>>img {
		object-fit: cover;
		width: 100% !important;
		margin: 0 auto;
	}

	.article_cantent>>>p {
		text-indent: 0 !important;
	}
}

.mianbao_item {
	margin: 0 20px;
	cursor: pointer;
}

.active {
	color: #ff6537;
	font-weight: bold;
}

.media_view {
	display: flex;
	flex-direction: row;
	border-bottom: 1px solid #f0eeef;
	margin-bottom: 20px;
}

.state_view2 .media_view {
	border: none;
}

.state_right {
	cursor: pointer;
}

.article_state {
	margin-top: 45px;
}

@media (min-width: 768px) {
	.article_state {
		margin: 40px auto;
		font-size: 14px;
		width: 100%;
		max-width: 1120px;
	}

	.article_cantent {
		margin-top: 30px;
		text-align: left;
	}
}</style>



// WEBPACK FOOTER //
// src/page/themeDetail.vue